var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.getUser ? _c('div', {
    staticClass: "platform-progress"
  }, [_c('v-expansion-panels', {
    staticClass: "elevation-10",
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.panel,
      callback: function callback($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "elevation": "10"
    }
  }, [_c('v-expansion-panel-header', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-icon', [_vm._v(" mdi-chevron-up ")])];
      },
      proxy: true
    }], null, false, 660978361)
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center full-width"
  }, [_c('div', {
    class: _vm.stepsLeft === 0 ? 'mr-8' : '0'
  }, [_vm._v(" " + _vm._s(_vm.$t("globals.platform.title", {
    name: _vm.$ls.get("config").name
  })) + " ")]), _vm.stepsLeft > 0 ? _c('div', {
    staticClass: "steps-count"
  }, [_vm._v(" " + _vm._s(_vm.stepsLeft) + " ")]) : _vm._e()])]), _c('v-expansion-panel-content', [_vm.stepsLeft !== 0 ? [_c('v-progress-linear', {
    attrs: {
      "height": "25",
      "value": _vm.progress,
      "rounded": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var value = _ref.value;
        return [_c('strong', [_vm._v(_vm._s(Math.ceil(value)) + "%")])];
      }
    }], null, false, 3002676263)
  }), _c('v-card', {
    staticClass: "info-card"
  }, [_c('v-sheet', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.steps, function (step) {
    return _c('v-list-item', {
      key: step.title,
      staticClass: "pa-0",
      attrs: {
        "disabled": step.done
      },
      on: {
        "click": function click($event) {
          return _vm.$router.push("".concat(step.path));
        }
      }
    }, [_c('v-list-item-icon', [_c('div', {
      staticClass: "circle-outline",
      class: step.done ? 'check-circle' : ''
    }, [step.done ? _c('v-icon', {
      attrs: {
        "size": "30px"
      }
    }, [_vm._v(" mdi-check ")]) : _vm._e()], 1)]), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(step.title) + " ")]), step.subtitle ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(step.subtitle) + " ")]) : _vm._e()], 1), step.path === '/modules/configuration' ? _c('v-list-item-action', [_c('button', {
      staticClass: "btn-delete",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.confirmDeleteStep(step);
        }
      }
    }, [_c('IconCustom', {
      attrs: {
        "color": _vm.$vuetify.theme.dark ? '#FFFFFF' : '#96A2AE',
        "name": "icn20_trash_can"
      }
    })], 1)]) : _vm._e()], 1);
  }), 1)], 1)] : _c('v-card', {
    staticClass: "success-steps"
  }, [_c('v-card-text', {
    staticClass: "mt-5 mb-5 text-center"
  }, [_c('helper-success-animation', {
    staticClass: "mb-4"
  }), _vm._v(" " + _vm._s(_vm.$t("globals.platform.configurationComplete")) + " ")], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "primary btn-close",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.closePlatformProgress
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('globals.closeButton')) + " ")])], 1)], 1)], 2)], 1)], 1), _vm.confirmDialog ? _c('helper-confirm-dialog', {
    attrs: {
      "show-dialog": _vm.confirmDialog,
      "text": _vm.$t('globals.platform.stepReallyDelete', {
        name: _vm.selectedStep.title
      })
    },
    on: {
      "closeConfirmDialog": _vm.closeConfirmDialog
    }
  }) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }